//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.BalloonsBuilder.js";
import "../Annotations/Annotations.PartsListContentsBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.TableStyleBuilder.js";
let d=[[[1,"Balloons",0,"Annotations.BalloonsBuilder",0],[1,"Contents",0,"Annotations.PartsListContentsBuilder",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"Settings",0,"Annotations.TableStyleBuilder",0]],[[["templateLocation"],"SetTemplateLocation",{},1,0],[[],"CreatePreviewView",{R_:{partListPreview:"Annotations.TableSection"}},0,0]],[]];
SPLM.Annotations.PlistBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PlistBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;